module.exports = __webpack_public_path__ + "static/img/screenshot-3.5ca2e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-3.png
// module id = B5d8
// module chunks = 0